import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  dateien: [],
  loading: false,
  loaded: false,
  error: null
}

// getters
const getters = {
  dateien (state) {
    return state.dateien
  },
  datei: (state) => (id) => {
    return state.dateien.find(datei => datei.id === id)
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadDateien ({commit}) {
    commit('setLoading', true)
    console.log('Dateien laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('dateien').onSnapshot(snapshot => {
      const dateien = []
      snapshot.forEach(doc => {
        if (!doc.data().delete) {
          dateien.push({
            ...doc.data(),
            id: doc.id
          })
        }
        commit('setLoadedDateien', dateien)
        commit('setLoading', false)
        commit('setLoaded', true)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createDatei ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('dateien').add(payload)
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteDateiData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('dateien').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteDatei', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateDateiData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('dateien').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateDatei', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedDateien (state, payload) {
    state.dateien = payload
  },
  createDatei (state, payload) {
    state.dateien.push(payload)
  },
  updateDatei (state, payload) {
    const datei = state.dateien.find(datei => {
      return datei.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        datei[key] = payload[key]
      }
    })
  },
  deleteDatei (state, payload) {
    let array = state.dateien
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.dateien = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dateien_alt.js